import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Atol4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ATOL4;
}

export default Atol4PoiTileEntity;
